import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Lista from "./Lista";
import Token from "./Token";
import TokenGeracao from "./TokenGeracao";

export default function Index({ match }) {
  return (
    <div className="content-wrapper">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} />
        <Route exact path={`${match.url}/lista`} component={Lista} />
        <Route exact path={`${match.url}/:codigo`} component={Token} />
        <Route
          exact
          path={`${match.url}/geracao/:usuarioId`}
          component={TokenGeracao}
        />
      </Switch>
    </div>
  );
}
